import { PkIcon } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import parseHtmlToReact from 'html-react-parser';
import { memo } from 'react';

import { useDrawVideoPlayerOptions } from '@apps/draw-centre/hooks';
import { useDrawCentreOptions } from '@apps/draw-centre/store';
import { useTranslateFn } from '@shared/Translate';

import * as styles from './styles.module.scss';

const VideoLabel = () => {
  const {
    options: {
      anotherSourceOptions: { anotherSource, videoOtherSource, videoOtherSourceText },
    },
  } = useDrawCentreOptions();
  const { isDrawReplay } = useDrawVideoPlayerOptions();
  const t = useTranslateFn();

  const otherSourceTracking = {
    category: 'Click',
    action: 'Go to uefa.tv',
    label: 'draw',
    name: 'draw_go_to_uefa_tv',
  };

  return (
    <>
      {!!isDrawReplay && (
        <div className={clsx('pk-d--flex pk-align-items--center', styles.videoLabel)}>
          <PkIcon
            className='pk-mr--xs'
            size={24}
            name='support-information'
            color='text-03'
            title={`${t('draw_video_finished')}`}
          />
          <span className='pk-font--base-regular pk-font-size--xs pk-font-size-md--s pk-line-height--md pk-text--text-02'>
            {t('draw_video_finished')}
          </span>
        </div>
      )}
      {anotherSource && !isDrawReplay && (
        <div className={styles.drawvideoOtherSource}>
          <a
            target='_blank'
            className='js-tracking-link'
            href={videoOtherSource}
            data-tracking={JSON.stringify(otherSourceTracking)}
          >
            {parseHtmlToReact(
              t('you_can_also_watch_the_draw_0', { replace: { 0: `<span>${t(videoOtherSourceText)}</span>` } }),
            )}
          </a>
        </div>
      )}
    </>
  );
};

export default memo(VideoLabel);
